<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12FYZZr/tc-custom/9781617750502.jpg?1702083978162" alt="This image is the cover for the book Home, AkashiClassics: Renegade Reprint Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home, AkashiClassics: Renegade Reprint Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Essays of the 1960s by a prominent African American voice who “demands rights—not conditional favors” (<i>The New York Times Book Review</i>)<i>.</i></b><br/>  <br/> Amiri Baraka, also known as LeRoi Jones, was known not only as a poet, playwright, and founder of the Black Arts movement, but also as one of the most provocative voices of the civil rights era and beyond.<br/>  <br/> These pieces, which span the years from 1960 to 1965, cover subjects ranging from Cuba to Malcolm X to street protests and soul food, and are accompanied by the author’s new introduction from 2009.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        LeRoi Jones
      </h2>
      
      <p class="authorDescription body article">LeRoi Jones, who later went by Amiri Barakas (1934–2014), was the author of numerous books of poetry, fiction, and nonfiction. He was named poet laureate of New Jersey by the New Jersey Commission for the Humanities, from 2002–2004. His short story collection <I>Tales of the Out & the Gone</I> (Akashic Books) was a <I>New York Times</I> Editors' Choice and won a 2008 PEN/Beyond Margins Award. He is also the author of <I>Home: Social Essays</I>, <I>Black Music</I>, and <I>The System of Dante's Hell</I>, among other works.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48720c5d